import './ScopeItem.scss';
import classNames from 'classnames';
import { Col } from 'antd';
import { InitiativeScopeItemActionButton } from './ScopeItemActionButton';
import { isPardotType } from '@sonar-software/sonar-ts-lib';
import { RuleStatus } from '@sonar-software/sonar-core';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import React, { useCallback } from 'react';
import { SonarRecord, SonarRecordRow, SonarRecordTags } from '@ui/records';
import { usePeriscopeActions, useSonarObjectReference } from '@hooks';
const getStatusName = (statusId) => {
    switch (statusId) {
        case 1:
            return RuleStatus.Active;
        case 2:
            return RuleStatus.Inactive;
        default:
            return '';
    }
};
export const InitiativeScopeItem = ({ initiativeId, itemId, removeAction, sonarObjectId }) => {
    const { displayName, isDeleted, parentDisplayName, parentSonarObjectId, relatedCounts, sonarObjectType, statusId, tagIds, versionNumber } = useSonarObjectReference(sonarObjectId);
    const { openPeriscope } = usePeriscopeActions();
    const status = getStatusName(statusId);
    const isActive = status ? status === RuleStatus.Active : undefined;
    const className = classNames('scope-item', { vanished: isDeleted });
    const handleScopeItemClick = useCallback(() => {
        if (!isDeleted && sonarObjectType) {
            openPeriscope({
                id: sonarObjectId,
                name: displayName !== null && displayName !== void 0 ? displayName : '',
                openedFromIndex: -1,
                type: sonarObjectType
            });
        }
    }, [displayName, isDeleted, openPeriscope, sonarObjectId, sonarObjectType]);
    const handleParentClick = useCallback(() => {
        if (sonarObjectType && parentDisplayName && parentSonarObjectId) {
            const parentObjectType = isPardotType(sonarObjectType) ?
                SonarObjectType.PardotEntity :
                SonarObjectType.SalesforceEntity;
            openPeriscope({
                id: parentSonarObjectId,
                name: parentDisplayName,
                openLeft: true,
                openedFromIndex: -1,
                type: parentObjectType
            });
        }
    }, [openPeriscope, parentDisplayName, parentSonarObjectId, sonarObjectType]);
    const actionButton = React.createElement(InitiativeScopeItemActionButton, { initiativeId: initiativeId, itemId: itemId, removeAction: removeAction, sonarObjectId: sonarObjectId });
    return (React.createElement(SonarRecord, { className: className, isActive: isActive, isDeleted: isDeleted, name: displayName !== null && displayName !== void 0 ? displayName : '', onClick: handleScopeItemClick, onClickParent: handleParentClick, parentName: parentDisplayName !== null && parentDisplayName !== void 0 ? parentDisplayName : '', relatedCounts: relatedCounts, rightEnd: actionButton, showType: true, sonarObjectId: sonarObjectId, sonarObjectType: sonarObjectType, versionNumber: versionNumber },
        React.createElement(SonarRecordRow, { condition: Boolean(tagIds.length) },
            React.createElement(Col, null,
                React.createElement(SonarRecordTags, { alignLeft: true, hideTagManager: true, sonarObjectId: sonarObjectId })))));
};
